import { Typography } from "@mui/material";
import { COLOR_GREY_9 } from "shared/theme/colors";
import { StyledEmptyWrapper } from "./styled";

type EmptyProps = {
  message?: string;
};

const EmptyContent = ({ message = "No Results Found" }: EmptyProps) => {
  return (
    <StyledEmptyWrapper>
      <Typography variant="bodyMRegular" color={COLOR_GREY_9}>
        {message}
      </Typography>
    </StyledEmptyWrapper>
  );
};

export default EmptyContent;
